// extracted by mini-css-extract-plugin
export var wordContainer = "_nm-0";